import { styled } from "@pigment-css/react";

// bleed removes the horizontal padding so children like Divider can span
// edge-to-edge. Horizontal padding is then applied per-section (see Section).
export const Card = styled("article")<{ bleed?: boolean; nested?: boolean }>(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[24],
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  border: `1px solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  borderRadius: theme.fieldSalesTwo.radius["38"],
  padding: `${theme.fieldSalesTwo.spacing[24]} ${theme.fieldSalesTwo.spacing[20]} ${theme.fieldSalesTwo.spacing[32]}`,
  boxSizing: "border-box",
  variants: [
    {
      props: { bleed: true },
      style: {
        padding: `${theme.fieldSalesTwo.spacing[24]} 0`,
      },
    },
    {
      props: { nested: true },
      style: {
        background: theme.fieldSalesTwo.colors.surface.glassLight,
        borderColor: theme.fieldSalesTwo.colors.surface.glassBorderBright,
      },
    },
  ],
}));
